import { useEffect, useRef } from 'react';
import cx from 'classnames';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useSelector } from 'react-redux';
import { SidebarItem, Button } from 'Elements';
import { ArrowNarrowUp } from 'tabler-icons-react';
import styles from 'partials/page-sidebar.module.scss';
import scrollStyles from 'partials/scroll-top.module.scss';

export const SidebarList = ({ isOpen, onClickItem }) => {
	const markers = useSelector((state) => state.marker);
	const osTargetRef = useRef(null);
	const body = document.body;
	// const storageItemName = 'osBodyScrollPosition';
	const osInstance = useRef(null);

	const scrollTo = (position = {}) => {
		if (osInstance.current) {
			osInstance.current.scroll(position, 550);
		} else {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	};

	// const initScroll = () => {
	// 	console.log('init');
	// 	let rememberedPosition = sessionStorage.getItem(storageItemName);
	// 	rememberedPosition =
	// 		typeof rememberedPosition === 'string'
	// 			? JSON.parse(rememberedPosition)
	// 			: null;

	// 	if (rememberedPosition?.y) {
	// 		console.log('rememberedPosition: ', rememberedPosition);
	// 		scrollTo({
	// 			top: rememberedPosition?.y ?? 0
	// 		});
	// 	}
	// };

	const showScroll = () => {
		const scrollPosition = osInstance.current.scroll().position.y;
		// sessionStorage.setItem(
		// 	storageItemName,
		// 	JSON.stringify({
		// 		y: scrollPosition
		// 	})
		// );

		if (scrollPosition > 350) {
			body.classList.add('scroll');
		} else {
			body.classList.remove('scroll');
		}
	};

	const scrollToTop = () => {
		scrollTo({ top: 0 });
	};

	useEffect(() => {
		osInstance.current = osTargetRef.current.osInstance();
	}, []);

	const wrapperClass = cx(styles.wrapper, {
		[styles.openPage]: !isOpen,
		[styles.closePage]: isOpen
	});

	return (
		<div className={wrapperClass}>
			<OverlayScrollbarsComponent
				ref={osTargetRef}
				className={styles.scrollbar}
				options={{
					className: 'os-theme-house',
					overflowBehavior: {
						x: 'hidden'
					},
					scrollbars: {
						autoHide: 'never',
						clickScrolling: true
					},
					callbacks: {
						onScroll: showScroll
					}
				}}>
				{markers?.list?.map((elem) => {
					return (
						<SidebarItem
							key={elem.id}
							data={elem}
							onClick={onClickItem}
						/>
					);
				})}
				<div className={styles.scrollToTop}>
					<Button
						className={[scrollStyles.button, styles.scrollTop].join(
							' '
						)}
						aria-label="scroll top"
						onClick={scrollToTop}>
						<ArrowNarrowUp size={20} />
					</Button>
				</div>
			</OverlayScrollbarsComponent>
		</div>
	);
};
